import { render, staticRenderFns } from "./ItsSalesForeignSalesOrder.vue?vue&type=template&id=ab1f8978&scoped=true&"
import script from "./ItsSalesForeignSalesOrder.vue?vue&type=script&lang=js&"
export * from "./ItsSalesForeignSalesOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab1f8978",
  null
  
)

export default component.exports